import useActiveRoute from 'hooks/useActiveRoute';

const useActiveRouteParameter = (key: string, defaultValue: number | string | null = null) => {
  const activeRoute = useActiveRoute();
  const value = activeRoute?.parameters?.find((item) => item.name === key)?.value;
  return value || defaultValue;
};

export default useActiveRouteParameter;
